import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { KitchenFormData } from '../../../app/data/models/kitchens/kitchenFormData';
import api from '../../../app/api/api';
import { fetchKitchenListAsync } from './kitchenListSlice';
import { toKitchenFormModel } from '../../../app/data/models/kitchens/kitchenFormModel';

export const updateKitchenAsync = createAsyncThunk<
  void,
  { restaurantId: string; kitchenId: string; kitchenDto: KitchenFormData }
>(
  'kitchens/update',
  async ({ restaurantId, kitchenId, kitchenDto }, thunkApi) => {
    try {
      await api.Kitchen.update(
        restaurantId,
        kitchenId,
        toKitchenFormModel(kitchenDto)
      );
      thunkApi.dispatch(fetchKitchenListAsync(restaurantId));
    } catch (error: unknown) {
      if (error instanceof Error) {
        return thunkApi.rejectWithValue({ error: error.message });
      }
      return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
    }
  }
);

export const updateKitchenSlice = createSlice({
  name: 'updateKitchen',
  initialState: { status: 'idle', dismiss: false },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateKitchenAsync.pending, (state) => {
      state.status = 'pendingUpdateKitchen';
    });
    builder.addCase(updateKitchenAsync.fulfilled, (state) => {
      state.status = 'idle';
      state.dismiss = true;
    });
    builder.addCase(updateKitchenAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
